import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

import { reactive, computed, ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import Modal from '@/hooks/modalType'
import { message } from '@dc-platform/dc-components'
import { planStatusEnum, remindTypeEnum } from '../dataConfig'
import { listByParamCodes } from '@/api/common'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { visitorProgramList, visitorProgramDelete } from '@/api/overseasSales/followUpManage'
import type { ParamCodeItem } from '@/typings/common'
import type { FbuVisitorProgramParams, FbuVisitorProgramListItem } from '@/typings/api/followUpManage'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'DcCosOFbuVisitorProgram' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n()
const router = useRouter()

// 计划状态枚举
const planStatusEnumAll = [{ label: '全部', lang: 'enum.all', value: undefined }, ...planStatusEnum]
const statusEnum = computed(() =>
  planStatusEnum.map((item) => ({
    name: t(item.lang),
    value: item.value,
    color: item.color
  }))
)
const paramCodeData: {
  [key: string]: ParamCodeItem[]
} = reactive({
  ofbu_follow_purpose: [], // 拜访目的
  ofbu_follow_mode: [] // 拜访方式（跟进方式）
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: ['ofbu_follow_purpose', 'ofbu_follow_mode']
  }).then((res) => {
    Object.assign(paramCodeData, res.data)
  })
}
onMounted(() => getByParamCodes())

const tableRef = ref()
const queryForm = reactive<FbuVisitorProgramParams>({
  timeType: 0
})

const columns = computed(() => [
  {
    title: t('visitor.title'),
    dataIndex: 'title',
    cosType: 'link',
    path: '/ofbu/visitorProgram/view',
    query: ['id'],
    fixed: 'left',
    width: 200
  },
  { title: t('visitor.customerNumber'), dataIndex: 'customerNumber' },
  { title: t('visitor.customerName'), dataIndex: 'customerName', width: 200 },
  { title: t('visitor.visitorMode'), dataIndex: 'mode', dicData: paramCodeData.ofbu_follow_mode },
  { title: t('visitor.purpose'), dataIndex: 'purpose', dicData: paramCodeData.ofbu_follow_purpose },
  { title: t('visitor.status'), dataIndex: 'status' },
  { title: t('visitor.remindType'), dataIndex: 'remindType', dicData: remindTypeEnum },
  { title: t('visitor.dutyByName'), dataIndex: 'dutyByName' },
  {
    title: t('visitor.visitortime'),
    dataIndex: ['startTime', 'endTime'],
    width: 350,
    cosType: 'timeRange',
    sorter: true
  },
  { title: t('common.createByName'), dataIndex: 'createByName' },
  { title: t('common.createTime'), dataIndex: 'createTime', sorter: true, width: 160 },
  { title: t('common.remark'), dataIndex: 'remark' },
  {
    title: t('common.action'),
    dataIndex: 'action',
    langWidth: {
      zh: 200,
      en: 260
    },
    fixed: 'right'
  }
])
const getList = (queryForm: FbuVisitorProgramParams, callBack: (res: any) => void) => {
  visitorProgramList(queryForm).then((res) => {
    callBack(res)
  })
}
const handleQueryChange = (type: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}

// 新增编辑函数
const triggerAddOrEdit = (id?: string) => {
  if (id) {
    router.push({ path: '/ofbu/visitorProgram/edit', query: { id } })
  } else {
    router.push('/ofbu/visitorProgram/add')
  }
}
const handleVisitComplete = (row: FbuVisitorProgramListItem) => {
  router.push({ path: '/ofbu/followUpRecord/visitingPlan', query: { planId: row.id } })
}
const handleDelete = (row: FbuVisitorProgramListItem) => {
  Modal.delete({
    name: row.title,
    onOk() {
      visitorProgramDelete(row.id).then(() => {
        message.success(t('tips.delSuccess'))
        tableRef.value?.delFetch()
      })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_CosRangePicker = _resolveComponent("CosRangePicker")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_dc_status = _resolveComponent("dc-status")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            search: queryForm,
            "onUpdate:search": _cache[12] || (_cache[12] = ($event: any) => ((queryForm) = $event)),
            onFetch: getList,
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosOfbuVisitorProgram"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('visitor.status')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio_group, {
                        value: queryForm.status,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.status) = $event)),
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (handleQueryChange('search')))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(planStatusEnumAll, (item) => {
                            return _createVNode(_component_a_radio_button, {
                              key: item.value,
                              value: item.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)(item.lang)), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"])
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('visitor.customerNumber')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customerNumber,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.customerNumber) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 100,
                        placeholder: _unref(t)('common.pleaseInput'),
                        allowClear: ""
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('visitor.customerName')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customerName,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.customerName) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 100,
                        placeholder: _unref(t)('common.pleaseInput'),
                        allowClear: ""
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('visitor.purpose')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ParamCodesSelect, {
                        value: queryForm.purpose,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.purpose) = $event)),
                        options: paramCodeData.ofbu_follow_purpose,
                        placeholder: _unref(t)('common.pleaseSelect'),
                        allowClear: ""
                      }, null, 8, ["value", "options", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('visitor.title')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.title,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.title) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 100,
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('common.department')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CustomerAreaCascader, {
                        type: "search",
                        appId: "cos_ofbu",
                        ids: queryForm.deptIdList,
                        "onUpdate:ids": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.deptIdList) = $event))
                      }, null, 8, ["ids"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('visitor.dutyByName')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UserSelect, {
                        value: queryForm.dutyBy,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.dutyBy) = $event)),
                        placeholder: _unref(t)('common.pleaseSelect'),
                        allowClear: ""
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('common.searchTime')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: queryForm.timeType,
                            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.timeType) = $event)),
                            style: {"width":"33%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select_option, { value: 0 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('common.createTime')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 1 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('visitor.visitortime')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"]),
                          _createVNode(_component_CosRangePicker, {
                            isOutputBeijingTime: "",
                            startTime: queryForm.startTime,
                            "onUpdate:startTime": _cache[9] || (_cache[9] = ($event: any) => ((queryForm.startTime) = $event)),
                            endTime: queryForm.endTime,
                            "onUpdate:endTime": _cache[10] || (_cache[10] = ($event: any) => ((queryForm.endTime) = $event)),
                            style: {"width":"67%"}
                          }, null, 8, ["startTime", "endTime"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (triggerAddOrEdit()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('btn.add')), 1)
                ]),
                _: 1
              })), [
                [_directive_permission, 'ofbu_visitor_add_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                appId: "cos_ofbu",
                taskType: "408",
                search: queryForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('btn.export')), 1)
                ]),
                _: 1
              }, 8, ["search"])), [
                [_directive_permission, 'ofbu_visitor_export_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, record, text }) => [
              (column.dataIndex === 'status')
                ? (_openBlock(), _createBlock(_component_dc_status, {
                    key: 0,
                    enums: statusEnum.value,
                    value: text
                  }, null, 8, ["enums", "value"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                      type: "link",
                      workCode: record.dutyBy,
                      disabled: record.status === 3,
                      onClick: ($event: any) => (handleVisitComplete(record))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('btn.completeVisit')), 1)
                      ]),
                      _: 2
                    }, 1032, ["workCode", "disabled", "onClick"])), [
                      [_directive_permission, 'ofbu_visitor_complete_btn']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                      type: "link",
                      disabled: record.status === 3,
                      onClick: ($event: any) => (triggerAddOrEdit(record.id))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('btn.edit')), 1)
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"])), [
                      [_directive_permission, 'ofbu_visitor_edit_btn']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                      type: "link",
                      disabled: record.status === 3,
                      onClick: ($event: any) => (handleDelete(record))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('btn.del')), 1)
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"])), [
                      [_directive_permission, 'ofbu_visitor_del_btn']
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})